import { settingByField } from "../../../Device/syncedSettings";

// Value vocabularies for the settings fields below — mirror the same local
// constants in DeviceModal.tsx (not imported from there: that file is
// intentionally never touched by this feature, and these are just the
// device/firmware's own fixed string vocabulary, effectively frozen — see
// SyncedSettings.kt in the firmware repo). If DeviceModal.tsx's copies ever
// change, these need updating to match.
export const CYCLE_MODE = [
  "FIXED",
  "DAY",
  "SIX_HOURS",
  "HOUR",
  "MINUTE",
  "QUARTER",
  "FIVE_MINUTES",
];
export const VIEW_MODE = ["FEED", "FAVORITE", "COLLECTIONS"];
export const SCREEN_STATE = ["OFF", "DEFAULT", "NIGHTMODE"];
export const CHIME_MODE = ["ONLY_CHIMES", "ONLY_STRIKES", "STRIKES_AND_CHIMES"];
export const NIGHT_MODE = ["AUTO", "SCHEDULE", "OFF"];

// Shared shape for every settings section component below: a plain values
// bag (same field names as the profile's own `values`, which are the same
// field names as a device's machines/{id} document) plus a single onChange
// callback. No Firestore write, no device id, no version — the caller
// (SettingsTab) owns where the value actually goes.
export type SettingsSectionProps = {
  values: Record<string, unknown>;
  onChange: (field: string, value: unknown) => void;
};

/**
 * The profile's value for `field`, or what the clock runs with while the field
 * is unset (syncedSettings.ts). Keeps the profile UI from showing a different
 * default than the clock actually uses.
 */
export const settingValue = <T>(
  values: Record<string, unknown>,
  field: string,
): T => (values[field] ?? settingByField(field)?.default) as T;
